import { signal } from '@preact/signals-core';

export const backgroundState = signal('black');

export const logoState = signal('visible');
